export function downloadFile(uri: string, name: string, onFail: () => void, onSuccess: (name: string) => void, extractFileNameFromHeader: boolean = false) {
  fetch(uri)
    .then(resp => {
      if (extractFileNameFromHeader && resp.headers.get('content-disposition') != null) {
        name = extractFilename(resp.headers.get('content-disposition'))
      }
      return resp.blob()})
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      onSuccess(name);
    })
    .catch(onFail);
}

function extractFilename(headerValue: string | null) {
  // Handle filename*=UTF-8'' format
  const utf8Match = headerValue?.match(/filename\*=UTF-8''(.*)/);

  // Return decoded UTF-8 filename if found
  if (utf8Match && utf8Match[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  // Handle regular filename format
  const regularMatch = headerValue?.match(/filename="([^"]*)"/);

  // Return decoded regular filename if found
  if (regularMatch && regularMatch[1]) {
    return decodeURIComponent(regularMatch[1]);
  }

  return '';
}
